export const normalize = <T extends Record<K, PropertyKey>, K extends keyof T>(list: T[], key: K) => {
  const map = {} as Record<T[K], T>;
  const ids: T[K][] = [];

  list.forEach((item) => {
    map[item[key]] = item;
    ids.push(item[key]);
  });

  return { map, ids };
};
